const mobileSizing = { width: 414, height: 896 };
const tabletSizing = { width: 834, height: 1112 };
const desktopSizing = { width: 1024, height: 1000 };

// Storybook doesn't export a type for the viewports, so we define our own here
// Configure viewport https://storybook.js.org/docs/essentials/viewport#options
export interface Viewport {
    name: string;
    styles: {
        height: string;
        width: string;
    };
    type: "desktop" | "mobile" | "tablet" | "other";
}

export const allViewports = {
    mobile: {
        name: "Mobile",
        styles: { width: `${mobileSizing.width}px`, height: `${mobileSizing.height}px` },
        type: "mobile"
    },
    tablet: {
        name: "Tablet",
        styles: { width: `${tabletSizing.width}px`, height: `${tabletSizing.height}px` },
        type: "tablet"
    },
    desktop: {
        name: "Desktop",
        styles: { width: `${desktopSizing.width}px`, height: `${desktopSizing.height}px` },
        type: "desktop"
    }
} satisfies Record<string, Viewport>;

export type ViewportsKeys = keyof typeof allViewports; // "mobile" | "desktop" | "tablet"
